import ShareHolders from './container';

export default ShareHolders;
